
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";
import { TokenInterceptor } from "app/authorized-http.service";
import { UtilsService } from "app/services/utils.service";
import { NewsletterListResource } from "app/models/NewsletterListResource";
import { NewsletterResource } from 'app/models/NewsletterResource';
import { HttpClient,HttpHeaders } from "@angular/common/http";
import { environment } from "app/baseUrl";
import { TagListResource } from 'app/models/TagListResource';


@Injectable()
export class NewsletterSubscribersService {

  constructor(private http: HttpClient, private httpa: TokenInterceptor, private utilsService: UtilsService) { }

  getAllSubscribers(url, body): Observable<NewsletterListResource> {
    return this.http.post<NewsletterListResource> (environment['url'] + url, body);
	}
		switchStatus(url): Observable<NewsletterResource> {
    return this.http.get<NewsletterResource>(environment['url'] + url)
  }

  upload(url, body): Observable<any> {
		return this.http.post(environment['url'] + url, body)
			
	}

	getExportFile(url, body): Observable<string> {
		let httpOptions = {
            headers: new HttpHeaders({
              'Content-Type':  'text/plain'
            })
        };
		return this.http.post<string>(environment.url + url, body,  {...httpOptions.headers, responseType: 'text' as 'json'});
	}

  private NewsletterListResource(res: Response) {
    let body = res.json()
    return body || [] // returneaza vector gol
  }
	deleteSubscribers(url): Observable<NewsletterResource> {
    return this.http.get<NewsletterResource>(environment['url'] + url)
	}
	private NewsletterResource(res: Response) {
    let body = res.json()
    return body || [] // returneaza vector gol
	}
	

	multipleDeleteSubscribers(url, body): Observable<NewsletterListResource> {
		return this.http.post<NewsletterListResource> (environment['url'] + url, body)
	}

	getAllTags(url): Observable<TagListResource> {
		return this.http.get<TagListResource>(environment.url + url)
	}
}
